import React from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { deleteAnnouncement } from '../../../../api/announcementApi';

export interface DeleteProps {
  done: () => void;
  id?: string;
  cancel: () => void;
}

function Delete({ done, id, cancel }: DeleteProps) {
  const { t } = useTranslation();
  const handleDelete = () => {
    if (!id) return;
    deleteAnnouncement(id)
      .then(() => {
        toast.success(t('Announcement successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete announcement'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the announcement')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default Delete;
